module.exports = __webpack_public_path__ + "static/media/scalar.1a52e0b4.png";